<template>
    <div class="row mt-4 pr-4 first-search-holder">
        <div class="col-11 first-search px-0">
            <div class="row h-100 no-gutters">
                <div class="col-lg-3">
                    <input type="text" :placeholder="$t('travels.navigation.design.service-title')" v-model="service.name">
                </div>
                <div class="col">
                    <input type="text" :placeholder="$t('travels.navigation.design.service-code')" v-model="service.code">
                </div>
                <core-drop-down
                    :items="countries"
                    valueAttribute="code"
                    labelAttribute="name_NL"
                    v-if="countries.length"
                    :selectedValue.sync="service.country"
                ></core-drop-down>
                <core-drop-down
                    :items="serviceTypes"
                    noLabel
                    labelAttribute="name_NL"
                    v-if="serviceTypes.length"
                    :selectedValue.sync="service.serviceType"
                ></core-drop-down>
                <div class="col">
                    <input type="text" :placeholder="$t('travels.navigation.design.service-duration')" v-model="service.duration">
                </div>
            </div>
        </div>
        <div class="col-1 pr-0 pl-2">
            <button class="check m-0" @click="saveJourney()"></button>
        </div>
    </div>
</template>

<script>
import Service from '@/services/hatsApi/Service'
import Geo from '@/services/hatsApi/Geo'

export default {
  data () {
    return {
      countries: [],
      serviceTypes: [],
      service: this.item
    }
  },
  props: {
    title: {
      type: Object,
      required: false
    },
    item: {
      type: Object,
      required: true
    },
    mode: {
      default: 'edit',
      type: String,
      required: false
    }
  },
  computed: {
    days () {
      let days = []
      for (let i = 1; i <= 31; i++) {
        days.push({ name: 'Day ' + i, value: i })
      }
      return days
    }
  },
  mounted () {
    Geo.getCountries().then((response) => {
      this.countries = response.data.data
    })

    Service.getServiceTypes().then((response) => {
      this.serviceTypes = response.data.data
    })
  },
  methods: {
    async saveJourney () {
      if (this.mode === 'add') {
        try {
          let newJourney = this.service
          newJourney.serviceTypeId = this.service.serviceType.id
          let response = await Service.createService(newJourney)
          this.$emit('journey-saved', response.data)
        } catch (error) {
          console.log(error)
        }
      } else {
        try {
          this.service.serviceTypeId = this.service.serviceType.id
          let response = await Service.updateService(this.service)
          this.$emit('journey-saved', response.data)
        } catch (error) {
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Service.vue